import React from 'react';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#111' }}>{title}</h2>
    <div style={{ color: '#374151', lineHeight: 1.8, fontSize: 15 }}>{children}</div>
  </div>
);

export default function Returns() {
  return (
    <div className="container" style={{ maxWidth: 820 }}>
      <h1 style={{ marginBottom: 6 }}>Returns & Refunds</h1>
      <p style={{ color: '#6b7280', marginBottom: 36 }}>Last updated: July 2026</p>

      <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '16px 20px', marginBottom: 32, fontSize: 15, color: '#065f46' }}>
        ✅ We want you to love your purchase. If you're not satisfied, we'll make it right.
      </div>

      <Section title="Return Window">
        <p>You may return most items within <strong>30 days</strong> of the delivery date for a full refund or exchange.</p>
      </Section>

      <Section title="Eligible Items">
        <p>To be eligible for a return, items must be:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li>In original, unused condition</li>
          <li>In original packaging (if applicable)</li>
          <li>Accompanied by the order number or proof of purchase</li>
        </ul>
      </Section>

      <Section title="Non-Returnable Items">
        <p>The following items cannot be returned:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li>Items marked as "Final Sale"</li>
          <li>Intimate apparel, swimwear, and pierced jewelry for hygiene reasons</li>
          <li>Items that have been worn, washed, or altered</li>
          <li>Items returned after the 30-day window</li>
        </ul>
      </Section>

      <Section title="How to Return">
        <ol style={{ paddingLeft: 20 }}>
          <li>Email us at <a href="mailto:support@styleme.club">support@styleme.club</a> with your order number and reason for return.</li>
          <li>We'll respond within 1–2 business days with return instructions and a return address.</li>
          <li>Ship the item back using a trackable shipping method (return shipping cost is the customer's responsibility unless the item is defective or we shipped the wrong item).</li>
          <li>Once we receive and inspect the item, your refund will be processed within 5–7 business days.</li>
        </ol>
      </Section>

      <Section title="Refunds">
        <ul style={{ paddingLeft: 20 }}>
          <li>Refunds are issued to the original payment method.</li>
          <li>Processing time: 5–7 business days after we receive the return.</li>
          <li>Original shipping charges are non-refundable (unless we made an error).</li>
        </ul>
      </Section>

      <Section title="Damaged or Wrong Items">
        <p>If you received a damaged, defective, or wrong item, please contact us within <strong>7 days</strong> of delivery with photos. We will send a replacement or issue a full refund at no cost to you, including return shipping.</p>
      </Section>

      <Section title="Exchanges">
        <p>We offer exchanges for different sizes or colors when available. Contact us at <a href="mailto:support@styleme.club">support@styleme.club</a> to request an exchange.</p>
      </Section>

      <Section title="Contact Us">
        <p>📧 <a href="mailto:support@styleme.club">support@styleme.club</a><br />
        We typically respond within 1–2 business days.</p>
      </Section>
    </div>
  );
}
